import { ThemeProvider } from '@mui/material/styles';
import * as ReactDOM from 'react-dom/client';

import App from './app/app';
import { darkBlueTheme } from './app/theme';

const showAdminPage = import.meta.env.VITE_SHOW_ADMIN === 'true';
const url =
  import.meta.env.VITE_STANDALONE_BACKEND_URL || document.location.origin;
const port = import.meta.env.VITE_STANDALONE_BACKEND_PORT;
const appConfig = {
  localServer: { url, port },
  showAdminPage,
  appName: 'mojira',
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ThemeProvider theme={darkBlueTheme}>
    <App config={appConfig} />
  </ThemeProvider>
);
